// src/redux/slices/dxfSlice.js
import { createSlice } from '@reduxjs/toolkit';

const dxfSlice = createSlice({
  name: 'dxf',
  initialState: {
    data: null, // DXF JSON verisi
    loadingMessage: '', // Yükleme durumu mesajı
    loadId: 0, // Yalnızca setDxfData'da artar — addUserEntity'de artmaz
  },
  reducers: {

    setDxfData: (state, action) => {
      state.data = action.payload;
      state.loadId += 1; // Gerçek DXF yükleme — sahne yeniden çizilmeli
    },
    clearDxfData: (state) => {
      state.data = null;
      state.loadId += 1;
    },
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload;
    },
    // Kullanıcının çizdiği objeleri DXF entities'e ekle (JBZ'ye kaydedilir)
    addUserEntity: (state, action) => {
      if (state.data && state.data.entities) {
        state.data.entities.push(action.payload);
      }
    },
    // Birden fazla entity ekle
    addUserEntities: (state, action) => {
      if (state.data && state.data.entities) {
        state.data.entities.push(...action.payload);
      }
    },
    // Entity sil (id veya handle ile)
    removeUserEntity: (state, action) => {
      if (state.data && state.data.entities) {
        const id = action.payload;
        state.data.entities = state.data.entities.filter(
          e => e.handle !== id && e._userEntityId !== id
        );
      }
    },
  },
});

export const { setDxfData, clearDxfData, setLoadingMessage, addUserEntity, addUserEntities, removeUserEntity } = dxfSlice.actions;

// Selectors
export const selectDxfData = (state) => state.dxf.data;

export default dxfSlice.reducer;
